module.exports = __webpack_public_path__ + "img/magento-services-integration_medium@2x.43bdc6f1.webp";